<template>
  <div class="wrapper">
    <div class="login-frame">
      <div class="login-form">
        <p class="login-title">{{title}}</p>
        <el-form :rules="loginRules" ref="loginForm" :model="loginInfo" :show-message="false">
          <el-row>
            <el-col>
              <el-form-item prop="username" >
                <el-input
                  placeholder="账户"
                  prefix-icon="iconfont icon-yonghu01-copy"
                  v-model="loginInfo.username"
                  @keyup.enter.native="handleFormLogin"
                  ></el-input>
            </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item prop="password">
                <el-input
                  placeholder="密码"
                  prefix-icon="iconfont icon-yuechi"
                  v-model="loginInfo.password"
                  type="password"
                  @keyup.enter.native="handleFormLogin"
                  ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item>
                <el-checkbox label="记住账户" v-model="rememberAccount"></el-checkbox>
                <el-checkbox label="自动登录" v-model="autoLogin"></el-checkbox>
                <!-- <a href="/#/forgotPassword">忘记密码</a> -->
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item>
                <el-button
                  type="primary"
                  class="login-btn"
                  @click.native.prevent="handleFormLogin()">登 录</el-button>
              </el-form-item>
            </el-col>
          </el-row>


          <el-row>
            <el-col>
              <el-form-item>
                <el-button
                  type="primary"
                  class="register-btn"
                  @click.native.prevent="handleToRegister()" plain>注册新机构</el-button>
            </el-form-item>
            </el-col>
          </el-row>

          <el-row style="margin-top:10px;">
            <el-col>
              <span>
               <a href="https://docs.shengxunwei.com/Post/0c822192-a35e-4d43-07b5-08d8e3da6269" target="_blank" >说明和介绍</a>
              </span>
            </el-col>
          </el-row>

           <el-row style="margin-top:10px;">
            <el-col>
               <span style="line-height:20px;">
               E-mail: cao.silhouette@msn.com<br/>
               微信：sheng-incog
              </span>
            </el-col>
          </el-row>
          
        </el-form>
      </div>
    </div>
    <!-- <div class="copy-right"></div> -->
  </div>
</template>
<script>
import { setToken } from "@/utils/auth";
import { hex_md5 } from "@/utils/MD5";

export default {
  name: "index",
  data() {
    return {
      title:window.Glob.Title,
      loginInfo: {
        username: this.$userContext.getAccount(),
        password: this.$userContext.getPassword()
      },
      rememberAccount: true,
      autoLogin:false,
      loginRules: {
        username: [
          { required: true, message: "请输入账户；", trigger: "change" }
        ],
        password: [{ required: true, message: "请输入密码；", trigger: "change" }]
      }
    };
  },
  created() {
    
    if(this.loginInfo.username != "" && this.loginInfo.password != "" &&
      this.loginInfo.username != undefined && this.loginInfo.password != undefined
    ){
        this.login(this.loginInfo);
    }

  },
  methods: {
    handleFormLogin() 
    {
      this.$refs.loginForm.validate((valid,data) => {

        if (valid == false)
        {
          this.$uiHelper.showValidationMessage(valid,data);
          return;
        }
        
         this.loginInfo.username = this.loginInfo.username.trim();
          let params = 
          {
            account: this.loginInfo.username,
            password: hex_md5(this.loginInfo.password).toUpperCase()
          };

          //保存账户
          if(this.rememberAccount){
            this.$userContext.setAccount(params.account);
          }else{
            this.$userContext.clearAccount();
          }

          //自动登录
          if(this.autoLogin){
              this.$userContext.setPassword(params.password);
          }else{
              this.$userContext.clearPassword();
          }

          this.login(params);

      });
    },
    login(loginInfo)
    {
        this.$userContextApi.login(loginInfo).then(res => 
          {
            if (res.data.successful) 
            {
              let loginResult = res.data.data;

              //保存登录信息
              this.$userContext.setLoginResult(res.data.data);

              //当前日期时间必须要放在能持久化存储的地方，如localStorage
              //因为有可能用户不走登录页面访问，有可能短时间之前登录过
              //session 还没失效，直接访问某个指定的页面，此时 token 还是有效的
              //但是很多页面右上角要显示实时计时，所以实时时间，不能localStorage存储
              //localStorage中最多只能存一下年月日期数据
              this.$dateTimeHelperApi.getDateTime().then(res=>
                {
                  if (res.data.successful)
                  {
                      this.$userContext.setDateTime(res.data.data);

                        //登录成功
                        //官方
                       this.$router.push({ path: "/weeklyReport/post" });

                      //私有化
                      // let webAddress = loginResult.webAddress;
                      // if(webAddress.lastIndexOf("/") != webAddress.length - 1)
                      // {
                      //   webAddress += "/";
                      // }
                      //  window.location.href = webAddress + "#/weeklyReport/post";

                  }
                }
              );
            } 
            else 
            {
              this.$alert(res.data.message, "提示");
            }
          });
    },

    handleToRegister() {
      // window.location.href = "/#/register";
      this.$router.push({ path: "/register" })
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
.wrapper {
  position: relative;
  height: 100vh;
  background: url("../assets/login-bg.jpg") ;//center no-repeat;
  background-size: 100%;
  //background-size: 100% 100%;
  .login-frame {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 400px;
    // margin: 0 50%;
    // height: 440px;
    margin-top: -250px;
    margin-left: -180px;
    .iconfont {
      font-size: 20px;
    }
    .iconfont.icon-yuechi {
      font-size: 25px;
    }
    .login-title {
      color: #36b5f8;
      font-size: 17px;
      margin-bottom: 22px;
    }

    .login-btn {
      font-size: 16px;
      color: #fff;
      background-color: #36b5f8;
      border-top-style: none;
      border-right-style: none;
      border-bottom-style: none;
      border-left-style: none;
      padding-top: 8px;
      padding-bottom: 8px;
      margin-top: 15px;
      width: 100%;
      height: 37px;
      cursor: pointer;
    }
    .register-btn {
      font-size: 16px;
      color: #36b5f8;
      background-color: #fff;
      border-color: #36b5f8;
      padding-top: 8px;
      padding-bottom: 8px;
      width: 100%;
      height: 37px;
      cursor: pointer;
    }
    .login-form {
      position: relative;
      height: 445px;
      padding: 30px;
      background-color: #fff;
     // border-radius: 5px;
     // box-shadow: 0 0 5px 2px #ccc;
      z-index: 2;
      font-size: 14px;

      a {
          color:#36b5f8;
          text-decoration: none;
      }

      a:hover{
        color:coral;
        text-decoration: underline;
      }

    }
    
  }

}
</style>



// WEBPACK FOOTER //
// src/views/login.vue